import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  SummaryObj: {
    Status: "ENTER",
    dateFrom: new Date(),
    dateTo: new Date(),
  },
  HeadObj: {
    VocTyp: "",
    VocName: "",
    VocNo: "",
    Version: "",
    TruckId: "",
    TruckName: "",
    DeliveryStatus: "",
    RefDocNo:""
  },
  DetailObj:{
    ItmCd:"",
    ItmName:"",
    Qty:"",
    ConfirmQty:"",
    VocTyp:"",
    VocNo:"",
    SrNo:"",
    BarCode:"",
    SuppRefNo1:"",
    
  }
 
};

const SliceDelivery = createSlice({
  name: "SliceDelivery",
  initialState: { value: initialState },

  reducers: {
    Set_SliceDelivery_SummaryObj_Init: (state, action) => {
      state.value.SummaryObj = initialState.SummaryObj;
    },

    Set_SliceDelivery_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    Set_SliceDelivery_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceDelivery_DetailObj: (state, action) => {
      state.value.DetailObj = action.payload;
    },
    SliceDelivery_Init: (state) => {
      state.value = initialState;
    },

    DeliveryList_Set: (state, action) => {
      state.value.DeliveryList = action.payload;
    },
    // Set_SliceDelivery_HeadObj_New_Set: (state, action) => {
    //   state.value.HeadObj.Date = action.payload.Date;
    // },
  },
});

export const {
  Set_SliceDelivery_SummaryObj_Init,
  Set_SliceDelivery_SummaryObj,
  SliceDelivery_Init,
  DeliveryList_Set,
  Set_SliceDelivery_HeadObj,
  Set_SliceDelivery_DetailObj
} = SliceDelivery.actions;

export default SliceDelivery.reducer;
